import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const team = [
  {
    name: "林澈",
    role: "内容主编",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20portrait%20illustration%20of%20a%20friendly%20young%20editor%20with%20glasses%20and%20short%20hair%2C%20warm%20orange%20background%2C%20minimal%20modern%20avatar%20style%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=team-member-01&orientation=squarish",
    bio: "负责动漫资讯的选题与审核，深耕动漫内容多年。",
  },
  {
    name: "苏岚",
    role: "资源运营",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20portrait%20illustration%20of%20a%20cheerful%20young%20woman%20curator%20with%20long%20hair%2C%20warm%20orange%20background%2C%20minimal%20modern%20avatar%20style%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=team-member-02&orientation=squarish",
    bio: "负责动漫资源的整理与分类，让每一部作品都能被找到。",
  },
  {
    name: "江野",
    role: "产品设计",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20portrait%20illustration%20of%20a%20calm%20young%20male%20designer%20with%20short%20neat%20hair%2C%20warm%20orange%20background%2C%20minimal%20modern%20avatar%20style%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=team-member-03&orientation=squarish",
    bio: "打造简洁易用的浏览体验，关注每一处交互细节。",
  },
  {
    name: "顾星",
    role: "社区联络",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20portrait%20illustration%20of%20a%20warm%20smiling%20young%20woman%20coordinator%20with%20medium%20hair%2C%20warm%20orange%20background%2C%20minimal%20modern%20avatar%20style%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=team-member-04&orientation=squarish",
    bio: "连接观众与创作者，收集反馈并持续优化平台。",
  },
];

const milestones = [
  { year: "2021", title: "平台启程", desc: "动漫网站正式上线，从基础的动漫资源浏览做起。" },
  { year: "2022", title: "资讯频道上线", desc: "新增动漫资讯板块，开始聚合最新动画新闻与专题报道。" },
  { year: "2023", title: "分类体系升级", desc: "完善题材分类与多维筛选，让资源检索更高效。" },
  { year: "2024", title: "体验全面焕新", desc: "重构浏览体验，强化搜索与个性化收藏功能。" },
];

const stats = [
  { value: "1600+", label: "精选动漫作品" },
  { value: "320+", label: "动漫资讯报道" },
  { value: "80万+", label: "月度访问用户" },
  { value: "12", label: "题材分类方向" },
];

export default function About() {
  useDocumentTitle(
    "关于我们 - 动漫网站",
    "了解动漫网站的品牌定位、发展理念、团队信息与发展历程，我们致力于为动漫爱好者提供优质资源与资讯。"
  );

  return (
    <div className="w-full">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8 pt-6 md:pt-10">
        <Breadcrumb items={[{ label: "关于我们" }]} />
      </div>

      <section className="mx-auto max-w-[1280px] px-4 md:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="min-w-0">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
              关于动漫网站
            </span>
            <h1 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-4 leading-snug">
              做动漫爱好者
              <br className="hidden md:block" />
              最信赖的资源与资讯平台
            </h1>
            <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed">
              动漫网站定位为动漫资源分享与资讯聚合平台，面向喜欢动漫的爱好者与观众。我们希望把精选的动漫全集与最新、最及时的动画资讯汇聚在一起，让每一位观众都能轻松找到想看的内容，随时了解动漫圈的动态。
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              从热血战斗到治愈日常，从科幻冒险到青春恋爱，我们相信好作品值得被发现，也值得被认真对待。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 mt-7 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-send-line" />
              联系我们
            </Link>
          </div>

          <div className="w-full h-64 md:h-96 rounded-lg overflow-hidden border border-background-200 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20inviting%20illustration%20of%20a%20cozy%20modern%20room%20filled%20with%20anime%20artwork%20posters%20and%20shelves%20of%20manga%20books%2C%20soft%20natural%20light%2C%20creative%20inspiring%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20no%20text%2C%20high%20detail&width=1200&height=900&seq=about-hero-01&orientation=landscape"
              alt="动漫网站平台介绍"
              title="动漫网站 - 精选动漫全集与动画资讯平台"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 border-y border-background-200/60">
        <div className="mx-auto max-w-[1280px] px-4 md:px-8 py-10 md:py-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <p className="font-heading font-extrabold text-2xl md:text-3xl text-primary-500">{stat.value}</p>
                <p className="text-sm text-foreground-600 mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 md:px-8 py-12 md:py-16">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 text-center">发展历程</h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">一路走来，只为给动漫爱好者更好的体验</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {milestones.map((m, index) => (
            <div key={m.year} className="relative p-5 rounded-lg bg-background-50 border border-background-200/70">
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 text-primary-600 font-heading font-bold">
                {index + 1}
              </span>
              <p className="font-heading font-bold text-accent-600 mt-4">{m.year}</p>
              <h3 className="font-heading font-semibold text-foreground-950 mt-1.5">{m.title}</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 md:px-8 pb-16 md:pb-24">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 text-center">团队成员</h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">一群热爱动漫的人，做着热爱的事</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {team.map((member) => (
            <div key={member.name} className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto rounded-full overflow-hidden bg-background-200">
                <img
                  src={member.avatar}
                  alt={`${member.name} - ${member.role}`}
                  title={`${member.name} - 动漫网站团队成员`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 mt-4">{member.name}</h3>
              <p className="text-xs text-primary-600 mt-1">{member.role}</p>
              <p className="text-xs text-foreground-500 mt-2.5 leading-relaxed">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}